import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";
import { Users, ShieldCheck, Zap } from "lucide-react";

const ArticlePage = () => {
  const breadcrumbs = [
    { label: "Elite", href: "/" },
    { label: "Blog", href: "/blog" },
    { label: "Painel IPTV Pós Pago para Revendedores", href: "/blog/painel-iptv-pos-pago-para-revendedores" }
  ];

  const sections = [
    {
      title: "Por que Revendedores Preferem o Pós-Pago",
      type: "grid" as const,
      content: (
        <>
          {[
            { t: "Fim do Estoque Parado", d: "Não perca dinheiro com créditos que expiram antes de serem vendidos.", i: <ShieldCheck /> },
            { t: "Crescimento Acelerado", d: "Escalabilidade imediata. Ative 10 ou 100 clientes no mesmo dia sem travas.", i: <Zap /> },
            { t: "Profissionalismo", d: "Acesse ferramentas de gestão que os servidores pré-pagos simples não oferecem.", i: <Users /> }
          ].map((item, i) => (
            <div key={i} className="p-8 rounded-3xl bg-white/[0.02] border border-white/5">
              <div className="w-12 h-12 rounded-2xl bg-electric/10 text-electric flex items-center justify-center mb-6">
                {item.i}
              </div>
              <h3 className="text-xl font-bold mb-3">{item.t}</h3>
              <p className="text-muted-foreground text-sm">{item.d}</p>
            </div>
          ))}
        </>
      )
    }
  ];

  return (
    <SEOPage
      category="Painel IPTV Pós Pago para Revendedores"
      title="Painel IPTV Pós Pago para Revendedores: O Guia do Sucesso"
      subtitle="Tudo o que você precisa saber para transformar sua revenda em um negócio escalável e lucrativo."
      heroImage="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80&w=1200"
      introParagraphs={[
        "Se você já trabalha com revenda de IPTV, sabe que o maior gargalo é o capital necessário para repor créditos. O modelo pós-pago foi desenhado especificamente para resolver essa dor do revendedor.",
        "Neste artigo, mostramos como migrar sua base atual para a nossa estrutura de elite e como aproveitar as ferramentas exclusivas do nosso painel para fidelizar seus clientes."
      ]}
      benefits={[
        { title: "Fluxo de Caixa", description: "Mantenha seu dinheiro no seu bolso e reinvista em marketing." },
        { title: "Escalabilidade", description: "Não há limites para o crescimento da sua rede de clientes." }
      ]}
      howItWorks={[
        { title: "Integração", description: "Migramos sua base de clientes com segurança." },
        { title: "Expansão", description: "Utilize nossos apps próprios para conquistar novos mercados." }
      ]}
      diferenciais={[
        { title: "Apps Flagship", description: "One X e P2 PRO: a melhor experiência de usuário do Brasil." }
      ]}
      faq={[
        { question: "É difícil migrar de outro servidor?", answer: "Não. Nossa equipe de suporte auxilia em todo o processo de migração para garantir que seus clientes não fiquem sem sinal." }
      ]}
      breadcrumbs={breadcrumbs}
      sections={sections}
      ctaTitle="🚀 Pronto para Subir de Nível?"
      ctaDescription="Mude para o pós-pago da P2 PRO e sinta a diferença no seu bolso."
      ctaButtonText="Migrar Minha Revenda"
    />
  );
};

export const Route = createFileRoute("/blog/painel-iptv-pos-pago-para-revendedores")({
  head: () => ({
    meta: [
      { title: "Painel IPTV Pós Pago para Revendedores - Lucro e Escala | P2 PRO" },
      { name: "description", content: "Descubra por que os maiores revendedores de IPTV do Brasil estão migrando para o sistema pós-pago. Mais lucro e zero estoque parado." }
    ],
  }),
  component: ArticlePage,
});
